<div class="flex layout-wrapper">
  <!-- SIDE NAV -->
  <isc-side-nav />

  <div class="main-layout ml-13">
    <!-- NETWORK STATUS -->
    @if (showConnection()) {
      <div class="flex items-center justify-center network-indicator"
           [class.is-online]="isAppOnline()"
           [class.is-offline]="!isAppOnline()">
        {{ isAppOnline() ? 'Connected to internet.' : 'Slow or no internet. Please check your connection.' }}
      </div>
    }

    <!-- MAIN CONTENT -->
    <main class="flex-1 container px-0"
          [class.is-network-indicator-visible]="showConnection()"
          [class.is-network-indicator-hidden]="!showConnection()">
      
      <!-- CHANGE THIS: Replace <ng-content /> with <router-outlet /> -->
      <router-outlet></router-outlet>
    </main>

    <!-- FOOTER -->
    <footer class="page-footer border-t border-grey flex flex-around bg-white">
      <span class="text-sm py-3 w-full text-center">
        <span class="text-light-gray">Copyrights &#169; {{ year() }}</span>
        <a class="text-primary" href="https://www.thelightbulb.ai" target="_blank"> thelightbulb.ai </a>
        <span class="text-light-gray">All rights reserved.</span>
      </span>
    </footer>
  </div>
</div>